import { render, staticRenderFns } from "./producer_app_bar.vue?vue&type=template&id=3d5d1044&scoped=true"
import script from "./producer_app_bar.vue?vue&type=script&lang=js"
export * from "./producer_app_bar.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3d5d1044",
  null
  
)

export default component.exports